export default __webpack_public_path__ + "static/media/blog-img245.414730eb.jpg";